import { FC, useMemo } from 'react'
import CustomToolTip from '../CustomToolTip'
import { AllFilterType } from './types';

interface Props {
    tctms: {
        label: string;
        value: string;
        Icon: React.ReactNode;
    }[];
    onClick: (tctm: string) => void;
    allFilters: AllFilterType;
    setAllFilters: (filters: AllFilterType) => void;
    applyFilter: (filters: AllFilterType) => void;
}

const TctmFilter: FC<Props> = ({ tctms, onClick, allFilters, setAllFilters, applyFilter }) => {

    const selectedTctms = useMemo(() => allFilters?.tctmFilter || [], [allFilters?.tctmFilter])

    const handleTcTmFilter = (tctm) => {
        onClick(tctm)
        const existingtctm = allFilters.tctmFilter || [];

        const updatedtctm = existingtctm.includes(tctm.label)
            ? existingtctm.filter((b) => b !== tctm.label) // remove if already selected
            : [...existingtctm, tctm.label];               // add if not selected

        const all_filters: AllFilterType = {
            ...allFilters,
            tctmFilter: updatedtctm
        };

        setAllFilters(all_filters);
        applyFilter(all_filters);
    }

    return (
        <div className="tctm__filters__container mx-1">
            {tctms.map(tctm => {
                const selectedClass = tctm?.value === 'invalid' ? 'tctm__invalid' : 'tctm__active'
                return (
                    <CustomToolTip title={tctm.label} placement="top" key={tctm.label}>
                        <button
                            className={`tctm__filter__button ${selectedTctms.includes(tctm.label) ? selectedClass : ''}`}
                            onClick={() => handleTcTmFilter(tctm)}
                        >
                            {tctm.Icon}
                        </button>
                    </CustomToolTip>
                )
            })}
        </div>
    )
}

export default TctmFilter